export default __webpack_public_path__ + "static/media/mic-select-meter.6b75712e.svg";